import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalAccionResolutionComponent } from '../modal-accion-resolution/modal-accion-resolution.component';
import { ChangeRequest, ChangeRequestLog, CommercialBehaviourPerGuaranteeTarget, Item, Quotation, ResponseLegacyDataDTO } from 'src/app/pages/dashboards/clients/interface/data.interface';
import { ScoringIngeService } from 'src/app/pages/dashboards/files-clients/service/scoring-inge.service';
import { EquifaxReportBD } from 'src/app/pages/dashboards/files-clients/interface/dicom-interface';
import { Observable } from 'rxjs';
import { ServiceInfoClientService } from 'src/app/pages/dashboards/files-clients/service/service-info-client.service';
import { InfoCompany } from 'src/app/pages/dashboards/files-clients/interface/company-client.interface';
import { SalesQuoteService } from 'src/app/pages/dashboards/service/sales-quote.service';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import { WhatsappFireNotificationModalComponent } from 'src/app/pages/dashboards/clients/components/whatsapp-fire-notification-modal/whatsapp-fire-notification-modal.component';


@Component({
  selector: 'app-modal-resolution-discount',
  templateUrl: './modal-resolution-discount.component.html',
  styleUrl: './modal-resolution-discount.component.scss'
})
export class ModalResolutionDiscountComponent {
  public item!: Item;
  public quotation!: Quotation;
  public dicom$: Observable<EquifaxReportBD>;
  public dicom: EquifaxReportBD | null;
  public infoClient$: Observable<InfoCompany>;
  public infoClient: InfoCompany | null;
  public legacySummaryInfo$: Observable<ResponseLegacyDataDTO>;
  public legacySummaryInfo: ResponseLegacyDataDTO | null;
  public type!: number;
  public loadingState: { [key: string]: boolean } = {
    dicom: true,
    infoClient: true,
    legacySummaryInfo: true
  };

  public icons = {
    faXmark,
    faCheck
  }

  public clientGuaranteeBehavior: CommercialBehaviourPerGuaranteeTarget | null = null;

  public isSmallScreen: boolean = false;
  public hasItemChanges: boolean | undefined = undefined;

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA)public data: any, private quoteService: SalesQuoteService, 
  private equifaxService: ScoringIngeService, private cdRef: ChangeDetectorRef, private serviceInfo: ServiceInfoClientService, private authService: AuthService,
  private matDialogRef: MatDialogRef<ModalResolutionDiscountComponent>,
  private breakpointObserver: BreakpointObserver) {
    this.item = data?.item ?? ({} as Item);
    this.quotation = data?.quotation ?? ({} as Quotation);
    this.type = data?.type ?? 0; 
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Handset, Breakpoints.Small]).subscribe(result => {
      this.isSmallScreen = result.matches;      
    });

    this.matDialogRef.backdropClick()
    .subscribe(() => this.matDialogRef.close(this.hasItemChanges));
  }

  ngOnInit(): void {
    this.getDicom();
    this.getInfoClient();
    this.getLegacySummaryInfo();
  }

  public getDicom() {
    this.dicom$ = this.equifaxService.getEquifaxReportBD(Number(this.quotation.customer.rut.split('-')[0]));
    this.dicom$.subscribe((data) => {
      this.dicom = data;
      this.loadingState['dicom'] = false;
    }, (error) => {
      this.loadingState['dicom'] = false;
    }
    );
  }

  public getInfoClient() {
    this.infoClient$ = this.serviceInfo.infoCompany(Number(this.quotation.customer.rut.split('-')[0]));
    this.infoClient$.subscribe((data) => {
      this.infoClient = data; 
      this.loadingState['infoClient'] = false;
    }, (error) => {
      this.loadingState['infoClient'] = false;
    });
  }

  public getLegacySummaryInfo() {
    this.legacySummaryInfo$ = this.quoteService.getLegacySummaryInfo(this.quotation.customer.rut);
    this.legacySummaryInfo$.subscribe((data) => {
      this.legacySummaryInfo = data;
      this.clientGuaranteeBehavior = this.getClientGuaranteeBehavior(this.item.targetId, data.commercialBehavioursPerGuaranteeTarget);
      this.loadingState['legacySummaryInfo'] = false;
    }, (error) => {
      this.loadingState['legacySummaryInfo'] = false;
    });
  }

  private getClientGuaranteeBehavior(targetId: number, data: CommercialBehaviourPerGuaranteeTarget[]): CommercialBehaviourPerGuaranteeTarget | null {
    if(!Array.isArray(data)) return null;
    return data.find((item) => Number(item.guaranteeTarget) === targetId) || null;
  }

  public rejectDisconunt() {
    const dataRequest =  {
      idCotizacion: this.data.idCotizacion,
      accion: 1 /*Approve*/,
      quoteItemId: this.data.item.id,
      userId: parseInt(this.authService.getRutUser()),
      companyId: Number(this.quotation.customer.rut.slice(0, -2))
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '42vw';
    //dialogConfig.height = '76vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = dataRequest;
    var ref = this.dialog.open(ModalAccionResolutionComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      if(result) {
        Swal.fire({
          icon: 'success',
          text: "Descuento Rechazado"
        });
        this.type = 1;
        this.hasItemChanges = true;
        this.refreshSalesQuote(this.quotation.id, this.item.id);
      }
    });
  }

  public aproveDiscount() {
    const dataRequest =  {
      idCotizacion: this.data.idCotizacion,
      accion: 2 /*Reject*/,
      quoteItemId: this.data.item.id,
      userId: parseInt(this.authService.getRutUser()),
      companyId: Number(this.quotation.customer.rut.slice(0, -2)),
      discount: this.item.discount,
      discountPorcent: this.item.discountPercentage
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '42vw';
    //dialogConfig.height = '76vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = dataRequest;
    var ref = this.dialog.open(ModalAccionResolutionComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      if(result) {
        Swal.fire({
          icon: 'success',
          text: "Descuento Aprobado"
        });
        this.type = 1;
        this.hasItemChanges = true;
        this.refreshSalesQuote(this.quotation.id, this.item.id);
      }
    });
  }

  private refreshSalesQuote(salesQuoteId: number, itemId: number ){
    this.quoteService.getSalesQuoteById(salesQuoteId)
    .subscribe({
      next: (updatedSalesQuote) => {
        this.quotation = {
          ...this.quotation,
          ...updatedSalesQuote
        };
        this.item = updatedSalesQuote.items.find((item) => item.id === itemId) || this.item;
        this.cdRef.detectChanges();
      }
    });
  }

  public converToNumber(a: string) : number {
    return Number(a);
  }

  public returnCorrectDate(date: Date | null) {
    const invalidDate = new Date('0001-01-01T00:00:00');
    if(!date) return null;
    const inputDate = new Date(date);
    return inputDate.getTime() === invalidDate.getTime() ? null : inputDate;
  }

  public getValidData(targetId: number) {
    this.legacySummaryInfo?.commercialBehavioursPerGuaranteeTarget.filter(
      (data) => this.converToNumber(data.guaranteeTarget) === targetId
    ) || null;
    return this.legacySummaryInfo?.commercialBehavioursPerGuaranteeTarget.filter(
      (data) => this.converToNumber(data.guaranteeTarget) === targetId
    ) || null;
  }

  public getLastReasonDiscount(): string | null {
    const filteredRequests = this.item?.changeRequests
      ?.filter((req: any) => req.changeTypeId === -3) || [];
    return filteredRequests.length > 0 ? filteredRequests[filteredRequests.length - 1].reason : null;
  }

  public lastRequestedDiscount(): ChangeRequest | null {
    const discountRequest = this.item?.changeRequests
    .filter((req: any) => req.changeTypeId === -3);
    return discountRequest.length > 0 ? discountRequest[discountRequest.length - 1] : null;
  }

  public getSaleQuoteHistoricLogs(): ChangeRequestLog[] {
    const logs = this.item.changeRequests
    .filter((req) => Array.isArray(req.changeRequestLogs))
    .flatMap(req => req.changeRequestLogs)
    .sort((a, b) => new Date(b.logDate).getTime() - new Date(a.logDate).getTime())
    .map((log) => ({...log, logDate: new Date(log.logDate + 'Z')}));
    return logs;
  }

  public OpenApproversModal(){
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '50vw';
      dialogConfig.height = '35vh';
      dialogConfig.maxWidth = '90vw';
      dialogConfig.maxHeight = '85vh';
      dialogConfig.data = {
        type: "discount",
        salesQuoteId: this.quotation.id,
        userName: this.quotation.originatorUser.name,
        clientName: this.quotation.customer.name,
        discountPercentage: this.item.discountPercentage,
      };
      this.dialog.open(WhatsappFireNotificationModalComponent, dialogConfig);
    }
  
}